import {createTranslationMessages} from '@backstage/core-plugin-api/alpha';
import {kubernetesTranslationRef} from '@backstage/plugin-kubernetes/alpha';

export const kubernetesPtbr = createTranslationMessages({
    ref: kubernetesTranslationRef,
    messages: {
        "kubernetesContentPage.permissionAlert.message": "Para visualizar objetos do Kubernetes, entre em contato com o administrador do portal para conceder as permissões 'kubernetes.clusters.read' e 'kubernetes.resources.read'.",
        "kubernetesContentPage.permissionAlert.title": "Permission required",
    },
});

export default kubernetesPtbr;
